module.exports = __webpack_public_path__ + "img/editada-31-1040x500.43de2eb1.jpg";